import { render, staticRenderFns } from "./technology.vue?vue&type=template&id=e5885850&scoped=true"
import script from "./technology.vue?vue&type=script&lang=js"
export * from "./technology.vue?vue&type=script&lang=js"
import style0 from "./technology.vue?vue&type=style&index=0&id=e5885850&prod&scoped=true&lang=less"
import style1 from "./technology.vue?vue&type=style&index=1&id=e5885850&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5885850",
  null
  
)

export default component.exports